import form from "../Form.module.css";
import { ControlledClickPopover } from "components/ClickPopover";
import {
  MenuSelectPerformance,
  IconPerformance,
} from "shared/SelectPerformance/SelectPerformance";
import { Identity } from "components/Identity";
import { IconChevronUp } from "components/Icons/IconChevronUp";
import { IconChevronDown } from "components/Icons/IconChevronDown";

import { useState } from "react";

import type { ActiveContext } from "shared/ContextSwitcher/store";
import type {
  SupportedPublicPerformanceTierKey,
  ExecutionTiersData,
} from "shared/SelectPerformance/useGetPerformanceTiers";

interface Props {
  contextOwner: ActiveContext;
  performanceTiers: ExecutionTiersData[];

  selectedPerformance: SupportedPublicPerformanceTierKey;
  setSelectedPerformance: (perf: SupportedPublicPerformanceTierKey) => void;
}

// NB: This component is also used in modal to apply dashboard parameters
// interactively
export function FieldExecutionTier(props: Props) {
  const { selectedPerformance, setSelectedPerformance } = props;

  const [isOpen, setIsOpen] = useState(false);

  function selectedOptionDisplay() {
    const option = props.performanceTiers.find(
      (tier) => tier.publicPerformanceTierKey === selectedPerformance
    );

    if (!option) {
      return <span className={form.fieldText}>Unset</span>;
    }

    return (
      <>
        <IconPerformance performance={option.publicPerformanceTierKey} />
        <span className={form.fieldText}>{option.displayName}</span>
      </>
    );
  }

  return (
    <label className={form.label}>
      <span>Execution tier</span>

      <ControlledClickPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        // TODO: position="below-full-width"
        position="below-align-left"
        content={({ close }) => (
          <MenuSelectPerformance
            activeContext={props.contextOwner}
            performanceTiers={props.performanceTiers}
            performance={selectedPerformance}
            setPerformance={setSelectedPerformance}
            close={close}
          />
        )}
      >
        <button type="button">
          {selectedOptionDisplay()}

          <Identity
            size="M"
            color="text-secondary"
            flip
            owner={props.contextOwner}
          />

          {!isOpen ? <IconChevronDown /> : <IconChevronUp />}
        </button>
      </ControlledClickPopover>
    </label>
  );
}
